// "Which peel is right for me?" — each answer adds points to VI Peel® (vi) or Cosmelan® (cos).
// The first question also picks which VI Peel® formula to recommend.
export const QUESTIONS = [
  {
    q: "What would you most like to improve?",
    options: [
      { label: "Melasma or deep, patchy pigment", cos: 3, formula: "VI Peel® Precision + Peptides" },
      { label: "Sun spots and uneven tone", vi: 1, cos: 1, formula: "VI Peel® Precision + Peptides" },
      { label: "Acne and breakouts", vi: 3, formula: "VI Peel® Purify" },
      { label: "Acne plus dark marks it left behind", vi: 2, formula: "VI Peel® Purify with Precision + Peptides" },
      { label: "Fine lines and aging", vi: 3, formula: "VI Peel® Advanced" },
      { label: "Dullness, texture or a general refresh", vi: 3, formula: "VI Peel® Original" },
    ],
  },
  {
    q: "How long have you had this concern?",
    options: [
      { label: "Years, and it keeps coming back", cos: 2 },
      { label: "It's fairly recent", vi: 1 },
      { label: "It's more about upkeep than one concern", vi: 2 },
    ],
  },
  {
    q: "Have you tried other treatments for it?",
    options: [
      { label: "Yes, without lasting results", cos: 2 },
      { label: "A few, with some results", vi: 1, cos: 1 },
      { label: "No, this would be my first peel", vi: 2 },
    ],
  },
  {
    q: "How do you feel about a home-care routine afterwards?",
    options: [
      { label: "Happy to follow a guided routine for a few months", cos: 2 },
      { label: "I'd prefer a simple post-peel kit for one week", vi: 2 },
    ],
  },
  {
    q: "What investment feels right?",
    options: [
      { label: "Around $350 a session", vi: 2 },
      { label: "Around $1,000 for my strongest result", cos: 2 },
      { label: "Not sure yet", vi: 0 },
    ],
  },
];

export const RESULTS = {
  cos: {
    service: "Cosmelan® Chemical Peel",
    name: "Cosmelan® Chemical Peel",
    price: "$1,000",
    page: "/treatments/cosmelan-peel-scottsdale",
    why: "Your answers point to stubborn, long-standing pigment. Cosmelan® is our most advanced depigmentation peel, combining an in-studio mask with a guided home routine that keeps melasma and dark spots under control.",
    expect: ["Redness and peeling for about 5 to 7 days", "Visible change in 2 to 4 weeks", "Full result over about 3 months"],
  },
  vi: {
    price: "$349",
    page: "/treatments/vi-peel-scottsdale",
    why: "Your answers suit a medical-grade VI Peel®: visible results, little discomfort and about a week of light peeling, with a simple post-peel kit to take home.",
    expect: ["Mild tingling for a few minutes", "Light peeling from about day 3 to day 7", "Brighter skin in about a week"],
  },
};

export const scoreQuiz = (answers) => {
  const picked = answers.map((a, i) => QUESTIONS[i].options[a]);
  const total = (k) => picked.reduce((s, o) => s + (o[k] || 0), 0);
  if (total("cos") > total("vi")) return RESULTS.cos;
  const formula = picked[0].formula || "VI Peel® Original";
  return { ...RESULTS.vi, service: formula, name: formula };
};
